import { buildUrlDownload, buildUrlFotoPerfil } from '../../../../config/config'
import localStorageService, { ACCESS_TOKEN_KEY } from '../../../../services/storage'

export const getLogoUnidade = async ({ sujeitoAtencao, unidadeStore }) => {
  const { convenio } = sujeitoAtencao?.dadosConvenio || {}
  const { convenioSistema } = convenio || {}
  const { convenioLogo } = convenioSistema || {}
  const token = await localStorageService.get(ACCESS_TOKEN_KEY)

  const urlLogo = convenioLogo?.urlDownload && buildUrlDownload(convenioLogo.urlDownload, token)
  const unidadeUtilizaFotoPerfilComoLogo = await unidadeStore.checkUnidadeUtilizaFotoPerfilComoLogo()
  const dadosUnidade =
    !urlLogo && unidadeUtilizaFotoPerfilComoLogo && (await unidadeStore.getLogoUnidadeLogada())
  const urlLogoUnidade = dadosUnidade ? buildUrlFotoPerfil(dadosUnidade.fotoPerfil, token) : null

  return urlLogoUnidade
}
